let SERVER_MODE = "online";

//only for development
globalThis.OTZAR_DEV_MODE = false;

//not recommend on development
globalThis.SERVER_MODE = SERVER_MODE;
globalThis.SERVER_MODE_USE_REAL_DOMAIN =
  globalThis.SERVER_MODE == "online" ? true : false;
//not recommend on development
globalThis.SET_DEFAULT = false;
//should we load the books
globalThis.DEV_LOAD_BOOKS = true;
//should we compress the books data
globalThis.DEV_COMPRESS = false;
//should we compress the hebrew code too (if yes then localstorage is used)
globalThis.DEV_COMPRESS_HEBREW = false;
//should we load system folders
globalThis.DEV_LOAD_SYSTEM_FOLDERS = true;
//should we create a index for books (its take about 3~ secs)
globalThis.DEV_CREATE_SEARCH_BOOKS_INDEX = true;

//dont change it unless you know what you doing
globalThis.DEV_NEW_VER = 1;

//compress mode (its run from exe file)
globalThis.DEV_COMPILE_MODE = false;

//these two go together
globalThis.DEV_CONNECT_USER_TO_FREE_AUTO = false;
globalThis.DEV_CONNECT_USER_TO_FREE_AUTO_LICENSE_CODE = 0b1 | 0b10 | 0b100;
globalThis.DEV_CONNECT_USER_TO_MEF_FREE_AUTO = false;

globalThis.DEV_IMAGES_FROM_CACHE = true;

//use webclients DB from 15.1
globalThis.DEV_USE_OLD_DB = true;

globalThis.DEV_ALLOWED_PAGES_BASIC = 150;
globalThis.DEV_ALLOWED_PAGES_PACKAGE = 40;

//not recommend on development
globalThis.DEV_FOR_TEST_OR_REAL_PROD = true;

//change this to force cache deleting
globalThis.BOOKS_CACHE_VER = 1;

//change this to apply user subscriptions on online
globalThis.DEV_ONLINE_SUBS_ON = true;

if (globalThis.SET_DEFAULT) {
  setTo("DEV_COMPRESS", true);
  setTo("DEV_COMPRESS_HEBREW", true);
  setTo("DEV_LOAD_BOOKS", true);
  setTo("DEV_LOAD_SYSTEM_FOLDERS", true);
  setTo("DEV_CREATE_SEARCH_BOOKS_INDEX", true);
}

//URL for updates server information
globalThis.DEV_UPDATES_INFO = "https://tablet.otzar.org/otzar-updates/";

if (globalThis.SERVER_MODE == "online")
  globalThis.DEV_ONLINE_USERS_DATA_TABLE = "otzar_user_data.";
else globalThis.DEV_ONLINE_USERS_DATA_TABLE = "";

function setTo(settings, defaultSetting) {
  if (globalThis[settings] != defaultSetting) {
    globalThis[settings] = defaultSetting;
    // console.info(`*${settings} IGNORE BECAUSE SET_DEFAULT IS TRUE*`);
  }
}

//some warnings to show
if (!globalThis.DEV_COMPRESS_HEBREW && globalThis.DEV_DEBUG)
  console.warn("*NOT USING LOCALSTORAGE FOR BOOKS AND WORDALT*");

if (!globalThis.DEV_LOAD_SYSTEM_FOLDERS && globalThis.DEV_DEBUG)
  console.warn("*SYSTEM FOLDERS NOT LOADED*");

// module.exports = { SERVER_MODE: SERVER_MODE };
